import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { galleryImages } from '../data/siteData';
import { PageHeader } from './About';

export default function Gallery() {
  const [active, setActive] = useState(null);

  const open = (idx) => setActive(idx);
  const close = () => setActive(null);
  const prev = (e) => {
    e?.stopPropagation();
    setActive((i) => (i - 1 + galleryImages.length) % galleryImages.length);
  };
  const next = (e) => {
    e?.stopPropagation();
    setActive((i) => (i + 1) % galleryImages.length);
  };

  return (
    <div>
      <PageHeader
        title="Project Gallery"
        subtitle="A look at recent asphalt paving, seal coating and crack sealing projects from across Western Canada."
        crumb="Gallery"
      />

      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {galleryImages.map((g, i) => (
            <button
              key={i}
              onClick={() => open(i)}
              className="group img-zoom relative rounded-lg overflow-hidden aspect-[4/3] shadow-md hover:shadow-2xl transition-shadow text-left"
            >
              <img src={g.src} alt={g.caption} className="w-full h-full object-cover" loading="lazy" decoding="async" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 via-slate-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <div>
                  <div className="text-xs font-bold tracking-widest text-amber-400 uppercase">
                    Project
                  </div>
                  <div className="text-white font-semibold mt-1">{g.caption}</div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </section>

      {active !== null && (
        <div
          className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4 animate-in fade-in"
          onClick={close}
        >
          <button
            onClick={close}
            className="absolute top-5 right-5 text-white/80 hover:text-white p-2"
            aria-label="Close"
          >
            <X size={28} />
          </button>
          <button
            onClick={prev}
            className="absolute left-4 md:left-8 text-white/80 hover:text-white p-3 bg-white/10 hover:bg-white/20 rounded-full transition-colors"
            aria-label="Previous"
          >
            <ChevronLeft size={24} />
          </button>
          <button
            onClick={next}
            className="absolute right-4 md:right-8 text-white/80 hover:text-white p-3 bg-white/10 hover:bg-white/20 rounded-full transition-colors"
            aria-label="Next"
          >
            <ChevronRight size={24} />
          </button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={galleryImages[active].src}
              alt={galleryImages[active].caption}
              className="w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
            />
            <div className="text-center mt-4 text-white">
              <div className="text-amber-400 text-xs font-bold tracking-widest uppercase">
                Project {active + 1} of {galleryImages.length}
              </div>
              <div className="font-semibold mt-1">{galleryImages[active].caption}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
